import { ReactElement } from 'react';

import { Box } from 'components/Box';
import { StaffTools } from 'components/Staff/StaffTools';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { useCurrentUserIsStaff } from 'modules/main/store/hooks/useCurrentUserIsStaff';
import { gutterWidth } from 'theme/theme';

type Props = {
  content: CmsApiPage;
};

export function FixedLayoutStaffTools({ content }: Props): ReactElement | null {
  const isStaff = useCurrentUserIsStaff();
  if (!isStaff) return null;

  return (
    <Box
      position="fixed"
      zIndex={102}
      top={[60 + gutterWidth / 2, null, null, 190]}
      right={gutterWidth / 2}
    >
      <StaffTools content={content} />
    </Box>
  );
}
